<template>
  <section>
    <!-- 荣誉资质 -->
    <v-sub_banner :msgObj="subBannerInfo"></v-sub_banner>
    <b-container fluid>
      <b-row class="justify-content-center honor">
        <b-col cols="11" sm="10" md="9" xl="7">
          <div v-for="item in textData" :key="item.id">
            <div class="honor-head">
              <img :src="item.HonorTitle" alt="" />
            </div>
            <div
              v-for="itemChild in item.titles"
              :key="itemChild.id"
              class="itemHonor"
              style="text-align: justify;"
            >
              <h3 class="honor-center" v-for="val in itemChild.honors">{{ val.text }}</h3>
        
              <p class="honor-center">{{ itemChild.p }}</p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
<script>
import Sub_banner from "../sub-banner.vue";
export default {
  components: {
    "v-sub_banner": Sub_banner,
  },
  data() {
    return {
      subBannerInfo: {
        // img: require("@/assets/images/sub_banner/ryzz.png"),
        img: require("@/assets/images/connect_banner.png"),
        title: "荣誉资质",
        subTitle: "Honors and qualifications",
      },
      textData: [
        {
          id: "1",
          HonorTitle: require("../../assets/images/index/honor1.png"),
          titles: [
            {
              id: "1-1",
              p: "民航数据共享交换平台",
              honors:[
                {
                  id:"1-1-1", text: "2021数字政府管理创新奖",
                },
                {
                  id:"1-1-2", text: "2021年度中国交通运输协会科学技术奖二等奖",
                },
                {
                  id:"1-1-3", text: "2020中国数字政府示范应用奖",
                },
               
                {
                  id:"1-1-4", text: "2020年互联网+政务服务创新应用APP",
                },
              ]
            },
            {
              id: "1-2",
              p: "民航行政审批服务平台",
              honors:[
                {
                  id:"1-2-1", text: "2020年度“中国互联网+政务服务”典型案例（十佳）",
                },
                {
                  id:"1-2-2", text: "2020年度部委“十大”优秀创新案例奖",
                }
              ]
            },
            {
              id: "1-3",
              honors:[
                {
                  id:"1-3-1", text: "2020政府信息化管理创新奖",
                },
                
              ],
              p: "民航行业监管执法系统",
            },
            {
              id: "1-4",
              honors:[
                {
                  id:"1-4-1", text: "位列“第二十一届（2022）中国政府网站绩效评估”国务院其他部门网站第6名",
                },
                {
                  id:"1-4-2", text: "2021年部委网站“十佳”优秀创新案例",
                },
                {
                  id:"1-4-3", text: "2016-2019年中国政府网站领先奖、优秀奖",
                },
               
                
              ],
              p: "中国民用航空局网站",
            },
            {
              id: "1-5",
              honors:[
                {
                  id:"1-5-1", text: "2019中国政府信息化管理创新奖",
                },
              ],
              p: "民航飞行标准监督管理系统",
            },
            {
              id: "1-6",
              honors:[
                {
                  id:"1-6-1", text: "2019年度中国交通运输协会科学技术二等奖",
                },
              ],
              p: "民用机场专用设备管理信息系统",
            },
            {
              id: "1-7",
              honors:[
                {
                  id:"1-7-1", text: "2011年度“中国航空运输协会科学技术奖三等奖”",
                },
              ],
              p: "民航固定资产投资项目管理信息系统",
            },
            {
              id: "1-8",
              honors:[
                {
                  id:"1-8-1", text: "荣获中国信息协会颁发的“2021中国政府信息化卓越贡献奖”",
                },
              ],
              p: "民航电子政务移动办公平台“民航e政”",
            },
            {
              id: "1-9",
              honors:[
                {
                  id:"1-9-1", text: "中国航空运输协会2020年度民航科学技术奖二等奖",
                },
              ],
              p: "全民航行李全流程跟踪系统",
            },
            {
              id: "1-10",
              honors:[
                {
                  id:"1-10-1", text: "2019中国政府信息化管理创新奖",
                },
              ],
              p: "飞标安全监管系统",
            },
          ],
        },
        {
          id: "2",
          HonorTitle: require("../../assets/images/index/honor2.png"),
          titles: [
          {
              id: "2-1",
              honors:[
                {
                  id:"2-1-1", text: "《中国民航高质量发展框架指标体系（试行）》首批试点单位",
                },
              ],
              p: "中国民航局信息中心",
            },
            {
              id: "2-2",
              honors:[
                {
                  id:"2-2-1", text: "课题研究优秀奖",
                },
              ],
              p: "《中国民航高质量发展框架指标体系（试行）》",
            },
            {
              id: "2-3",
              honors:[
                {
                  id:"2-3-1", text: "入选2021信息化科技创新推荐目录",
                },
              ],
              p: "《以民航局“互联网+政务服务”评价指标体系研究及试点应用推进民航高质量发展》",
            },
            {
              id: "2-4",
              honors:[
                {
                  id:"2-4-1", text: "2019年中华全国总工会“全国工人先锋号”荣誉称号",
                },
              ],
              p: "信息中心运行保障处",
            },
            {
              id: "2-5",
              honors:[
                {
                  id:"2-4-1", text: "全国民航工会“全国民航工人先锋号”荣誉称号",
                },
              ],
              p: "信息中心安全监管系统建设处",
            },
            
          ],
        },
      ],
    };
  },
  watch: {},
  created() {},
  mounted() {
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      let screenWidth = window.innerWidth;
      this.setReSize(screenWidth);
    };
    this.setReSize(window.innerWidth);
  },
  methods: {
    setReSize(screenWidth) {
      if (screenWidth > 576) {
        this.subBannerInfo.img = require("@/assets/images/connect_banner.png");
      } else {
        this.subBannerInfo.img = require("@/assets/images/common_m.png");
      }
    },
  },
};
</script>
<style scoped>
@import "../../assets/css/honor.css";
</style>
<style lang="less">
@media (max-width: 575px) {
  .honor-head {
    margin-bottom: 0;
  }
  .itemHonor {
    padding:3% 0;
    box-sizing: border-box;
    margin: 0 auto;
  }
  .honor-head img {
    transform: scale(0.6);
  }
  h3.honor-center {
    font-size: 15px;
    text-align: center;
  }
  p.honor-center {
    font-size: 13px;
    text-align: center;
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .honor-head img {
    transform: scale(0.8);
  }
  h3.honor-center {
    font-size: 16px;
    text-align: center;
  }
  p.honor-center {
    font-size: 14px;
    text-align: center;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .honor-head img {
    transform: scale(0.9);
  }
  h3.honor-center {
    font-size: 18px;
    text-align: center;
  }
  p.honor-center {
    font-size: 15px;
    text-align: center;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  h3.honor-center {
    font-size: 20px;
    text-align: center;
  }
  p.honor-center {
    font-size: 16px;
    text-align: center;
  }
}
@media (min-width: 1200px) {
  h3.honor-center {
    font-size: 22px;
    text-align: center;
  }
  p.honor-center {
    font-size: 18px;
    text-align: center;
  }
}
</style>
